import { Variants } from 'framer-motion';

// ====================================
// 🎬 FRAMER MOTION VARIANTS
// 애니메이션 상태 정의
// ====================================

// -------------------------------------
// Fade Animations
// -------------------------------------

export const fadeVariants: Variants = {
	initial: { opacity: 0 },
	animate: { opacity: 1 },
	exit: { opacity: 0 },
};

// -------------------------------------
// Modal Animations
// -------------------------------------

export const modalOverlayVariants: Variants = {
	initial: { opacity: 0 },
	animate: { opacity: 1 },
	exit: { opacity: 0 },
};

export const modalContentVariants: Variants = {
	initial: { opacity: 0, y: 30, scale: 0.95 },
	animate: { opacity: 1, y: 0, scale: 1 },
	exit: { opacity: 0, y: 30, scale: 0.95 },
};

// -------------------------------------
// Dropdown Animations
// -------------------------------------

export const dropdownVariants: Variants = {
	initial: { opacity: 0, y: -8, scaleY: 0.95 },
	animate: { opacity: 1, y: 0, scaleY: 1 },
	exit: { opacity: 0, y: -8, scaleY: 0.95 },
};

// -------------------------------------
// Slide Animations
// -------------------------------------

export const slideUpVariants: Variants = {
	initial: { opacity: 0, y: 20 },
	animate: { opacity: 1, y: 0 },
	exit: { opacity: 0, y: -20 },
};

export const slideDownVariants: Variants = {
	initial: { opacity: 0, y: -20 },
	animate: { opacity: 1, y: 0 },
	exit: { opacity: 0, y: 20 },
};

export const slideLeftVariants: Variants = {
	initial: { opacity: 0, x: 20 },
	animate: { opacity: 1, x: 0 },
	exit: { opacity: 0, x: -20 },
};

export const slideRightVariants: Variants = {
	initial: { opacity: 0, x: -20 },
	animate: { opacity: 1, x: 0 },
	exit: { opacity: 0, x: 20 },
};

export const slideHorizontalVariants: Variants = {
	initial: (direction: 'left' | 'right') => ({
		opacity: 0,
		x: direction === 'left' ? -200 : 200,
	}),
	animate: { opacity: 1, x: 0 },
	exit: (direction: 'left' | 'right') => ({
		opacity: 0,
		x: direction === 'left' ? 200 : -200,
	}),
};

// -------------------------------------
// Scale Animations
// -------------------------------------

export const scaleVariants: Variants = {
	initial: { opacity: 0, scale: 0.8 },
	animate: { opacity: 1, scale: 1 },
	exit: { opacity: 0, scale: 0.8 },
};

export const scaleSpringVariants: Variants = {
	initial: { opacity: 0, scale: 0.8 },
	animate: { opacity: 1, scale: 1 },
	exit: { opacity: 0, scale: 0.8 },
};
